/**
 * Type of value to be checked.
 * tag: 1869
 * @readonly
 * @enum {number} (int)
 */
export enum ValueCheckType {
  PriceCheck = 1,
  NotionalValueCheck = 2,
  QuantityCheck = 3,
}
